// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Receipt40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Receipt40Filled: FC<Receipt40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M4 36V7.429c0-.943.336-1.75 1.007-2.422C5.68 4.336 6.486 4 7.43 4H32.57c.943 0 1.75.336 2.422 1.007A3.302 3.302 0 0 1 36 7.43V36H4Zm11.429-6.857h13.714v-3.429H15.429v3.429Zm-4.572-7.429h18.286v-3.428H10.857v3.428Zm0-7.428h18.286v-3.429H10.857v3.429Z" />
        </svg>
    );
};

export default Receipt40Filled;
